import { render } from "./FooterStyleEight.vue?vue&type=template&id=7e23260c"
import script from "./FooterStyleEight.vue?vue&type=script&lang=js"
export * from "./FooterStyleEight.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__